import { render, staticRenderFns } from "./regetModal.vue?vue&type=template&id=3ea4a0bc&"
import script from "./regetModal.vue?vue&type=script&lang=ts&"
export * from "./regetModal.vue?vue&type=script&lang=ts&"
import style0 from "./regetModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports